import React, { useState, useEffect } from 'react';
import TikTokFeed from './TikTokFeed';
import NewsFeed from './NewsFeed';
import { useParams, useLocation } from 'react-router-dom';

// Detect if user is on mobile (same logic as App.tsx)
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const FeedRouter: React.FC = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const params = useParams<{ id?: string; slug?: string }>();
  const location = useLocation();

  console.log('[FeedRouter] 🔄 Routing analysis:', {
    isMobile,
    params,
    pathname: location.pathname,
    isPostUrl: location.pathname.includes('/post/'),
    isTagUrl: location.pathname.includes('/tag/'),
    extractedId: params.id,
    extractedSlug: params.slug
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Mobile renders TikTokFeed, Desktop renders NewsFeed
  // For mobile, pass URL parameters so TikTokFeed knows about specific posts
  return isMobile ? <TikTokFeed /> : <NewsFeed />;
};

export default FeedRouter; 